const UsersEndpoints = {
      users(reqData: any) {
        return {
          url: "auth/user",
          data: reqData["reqBody"],
          headers: reqData["headers"],
        };
      }
    };
export default UsersEndpoints;